

<section *ngIf="!isLoading && (help?.subVideoHelp || help?.videoName)">
  <ng-container *ngIf="help.subVideoHelp.length === 1; else mutlipleVideos">
    <ng-container *ngIf="help.subVideoHelp[0].videoName">
      <p *ngIf="help.subVideoHelp[0].description">{{help.subVideoHelp[0].description}}</p>
      <video #videoElement autoplay controls="true" controlslist="nodownload" [src]="baseUrl + '/videos/' + help.subVideoHelp[0].videoName">
      </video>
    </ng-container>

  </ng-container>

  <ng-template #mutlipleVideos>
    <h2>Aides vidéos</h2>
    <mat-accordion>
      <ng-container *ngFor="let help of help.subVideoHelp">
        <mat-expansion-panel *ngIf="help.videoName" (opened)="videoElement.play()">
          <mat-expansion-panel-header>
            <!-- <mat-panel-title>
              {{help.title}}
            </mat-panel-title> -->
            <mat-panel-description *ngIf="help.description">
              {{help.description}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <video #videoElement controls="true" controlslist="nodownload" [src]="baseUrl + '/videos/' + help.videoName">
          </video>
        </mat-expansion-panel>
      </ng-container>


    </mat-accordion>
  </ng-template>

</section>

<p style="text-align: center;" *ngIf="!isLoading && (!help?.subVideoHelp || help?.subVideoHelp?.length === 0)">Il n'y a pas d'aide vidéo.</p>

<mat-spinner *ngIf="isLoading" [diameter]="50"></mat-spinner>

<div class="btn_action">
  <button type="button" (click)="dialogRef.close(false)">Fermer</button>
</div>
